import React, { useState } from 'react';
import { ButttonDSCustom } from '@/presentation/reusables/Button/Button-DS';
import arrowDownIcon from '../../../../../../assets/icons/icon-arrow-down.svg';
import arrowDownIconDisabled from '../../../../../../assets/icons/flecha-disabled.svg';
import { Icon } from '../../../../../components';
import Interactive from '../Interactive';

export const ToggleNew = (props: any) => {
  const { onClick, animationExternal, itStartsOpened } = props;
  const [animation, setAnimation] = useState(itStartsOpened || false);

  return (
    <ButttonDSCustom
      name={`Ver ${itStartsOpened ? 'menos' : 'más'}`}
      icon={itStartsOpened ? 'chevron-up' : 'chevron-down'}
      iconAfter
      onClick={() => {
        if (onClick && typeof onClick === 'function') {
          onClick();
        }
        if (!animationExternal) {
          setAnimation(!animation);
        }
      }}
    />
  );
};
const Toggle = (props: any) => {
  const {
    onClick,
    sizeButton,
    sizeIcon,
    ref,
    animationEffect,
    animationExternal,
    disabled,
    itStartsOpened
  } = props;
  const [animation, setAnimation] = useState(itStartsOpened || false);

  const evalEffect = () => {
    if (animationExternal) {
      return animationEffect;
    }
    return animation;
  };

  return (
    <Interactive
      ref={ref}
      bkgColorEnabled="none"
      bkgColorHover="#E2DFFD"
      bkgColorFocus="#C6C0FC"
      bkgColorPressed="#C6C0FC"
      customized
      height={sizeButton || '40px'}
      width={sizeButton || '40px'}
      onClick={() => {
        if (onClick && typeof onClick === 'function') {
          onClick();
        }
        if (!animationExternal) {
          setAnimation(!animation);
        }
      }}
      borderRadius="4px"
    >
      <Icon
        customized
        height={sizeIcon || '40px'}
        maxWidth={sizeIcon || '40px'}
        justifyContent="center"
        alignItems="center"
        rotationDeg={evalEffect() ? 180 : 0}
      >
        <img
          src={!disabled ? arrowDownIcon : arrowDownIconDisabled}
          alt="other"
        />
      </Icon>
    </Interactive>
  );
};

Toggle.defaultProps = {
  disabled: false
};

export default Toggle;
